import { Observable } from "rxjs";

import type { ConfirmationCodeRequest, ExtendedApiResponse } from '@coin-depo-types';

export interface AuthFacade {
  parentId?: string;

  login(data: any): Observable<any>;
  logout(redirect?: boolean, backend?: boolean, onLogOut?: () => void): void;
  loginProvider?(res: any): void;

  sendEmailVerificationCode(
    email: string,
    lang: string
  ): Observable<any>;

  currentUser: {
    sLoading$: Observable<boolean>;
    sLoaded$: Observable<boolean>;
    sData$: Observable<any>;
    data$: Observable<any>;
  };

  userData: {
    // full later
    username: string;
    email: string;
    is_email_verified?: boolean;
    id?: number;
  };

  accessToken: string;

  getConfirmationCode(data?: ConfirmationCodeRequest): Observable<boolean | ExtendedApiResponse<{retry_after_ms?: number;}>>

  isLoggedIn: boolean;
}